export default __webpack_public_path__ + "static/media/under-construction.8e1f304f.svg";